import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableSignUserBase } from '../model/table-sign-user-base';
import { take, map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Signatory } from '../model/signatory';
import { SignatoryDTO } from '../model/signatory-dto';
import { SignatoryFilter } from '../model/signatory-filter';

const CONTROLLER = 'signatory';
@Injectable({
  providedIn: 'root'
})
export class SignatoryService {
  tableSignUserBase: TableSignUserBase;

  constructor(private translate: TranslateService, private http: HttpClient) {
    this.initializeTable();
    
    this.translate.onLangChange.subscribe(() => {
      this.initializeTable();
    });
  }

  private initializeTable(): void {
    this.tableSignUserBase = new TableSignUserBase(this.translate);
    this.tableSignUserBase.createInitObject().pipe(take(1)).subscribe(x => 
      x.subscribe(() => this.OnInit())
    );
  }

  OnInit(): void {
  }

  public listActives(value: SignatoryFilter) {
    const filters = {
      active: true,
      skip: value.skip,
      take: value.take,
      name: value.name ? value.name : '',
      obfuscateMail: value.obfuscateMail,
      obfuscateSsn: value.obfuscateSsn,
      obfuscateTelephone: value.obfuscateTelephone
    };
    return this.listWithFilter(this.sanitizeFilters(filters));
  }

  public insert(signatory: SignatoryDTO): Promise<any> {
    return this.http.post(CONTROLLER, signatory).toPromise();
  }

  public update(id, signatory: SignatoryDTO): Promise<any> {
    return this.http.put(CONTROLLER.concat('/').concat(id), signatory).toPromise();
  }

  public inactiveMany(ids: Array<number>): Promise<any> {
    return this.http.post(CONTROLLER.concat('/inactiveMany'), ids).toPromise();
  }

  public get(id: number, obfuscateMail: boolean): Observable<any> {
    return this.http.get<Signatory>(CONTROLLER + '/' + id + '?obfuscateMail=' + obfuscateMail)
      .pipe(
        map((response: Signatory) => response),
        catchError(this.handleError)
      );
  }

  private listWithFilter(filters): Observable<any> {
    return this.http.get(CONTROLLER, { params: filters }).pipe(map((dataList: any) => {
      const lstReturn: Array<Signatory> = [];
      Object.assign(lstReturn, dataList.value);
      lstReturn.map(x => {
        x.signatureType = Object.assign({}, this.tableSignUserBase.signatureType.Get(x.signatureType));
        x.subscriberType = Object.assign({}, this.tableSignUserBase.subscriberType.Get(x.subscriberType));
      });
      return lstReturn.sortBy('name');
    }));
  }

  private sanitizeFilters(filters) {
    return Object.keys(filters).reduce((accumulator, key) => {
      if (filters[key] !== undefined && filters[key] !== null) {
        accumulator[key] = filters[key];
      }
      return accumulator;
    }, {});
  }

  private handleError(errorResponse: Response) {
    console.log(errorResponse.statusText);
    return throwError(errorResponse || 'Server error');
  }

}
